/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file authentication hooks
 * @author Colin Walters
 * @module Epic.VideoApp.Hooks.Auth.Index
 */

export * from "./useHardwareTestAuthentication";
export * from "./useVideoCallAuthentication";
